/*
******************************************
============================================
* Generic Ajax
============================================
********************************************
*/

/*
	This function is a wrapper of ajax call from the page.
	
	@param
	dataType : The type of data that you're expecting back from the server.
	method	 : The HTTP method to use for the request (e.g. "POST", "GET").
	url		 : A string containing the URL to which the request is sent.
	data		 : Data to be sent to the server
*/
function ajaxWrapper({
  dataType,
  method,
  url,
  data,
  contentType = 'application/x-www-form-urlencoded; charset=UTF-8'
}) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      method,
      data,
      contentType,
      cache: false,
      dataType
    })
      .done(response => {
        return resolve(response);
      })
      .fail(error => {
        return reject(error);
      });
  });
}

/*
	This function is for expected json data from the server when "GET" method
	
	@param
	url		 			: A string containing the URL to which the request is sent.
	data	 			: Data to be sent to the server
*/
export function jsonGet(url, data = {}) {
  const requiredParam = {
    dataType: 'json',
    method: 'GET',
    contentType: 'application/json',
    url,
    data
  };
  return ajaxWrapper(requiredParam);
}

/*
	This function is for expected json data from the server when "POST" method
	
	@param
	url		 			: A string containing the URL to which the request is sent.
	data	 			: Data to be sent to the server
*/
export function jsonPost(url, data = {}) {
  const requiredParam = {
    dataType: 'json',
    method: 'POST',
    contentType: 'application/json',
    url,
    data
  };
  return ajaxWrapper(requiredParam);
}

/*
	This function is for expected html data from the server when "GET" method
	
	@param
	url		 			: A string containing the URL to which the request is sent.
	data	 			: Data to be sent to the server
*/
export function htmlGet(url, data = {}) {
  const requiredParam = {
    dataType: 'html',
    method: 'GET',
    url,
    data
  };
  return ajaxWrapper(requiredParam);
}

/*
	This function is for expected html data from the server when "POST" method
	
	@param
	url		 			: A string containing the URL to which the request is sent.
	data	 			: Data to be sent to the server
*/
export function htmlPost(url, data = {}) {
  const requiredParam = {
    dataType: 'html',
    method: 'POST',
    url,
    data
  };
  return ajaxWrapper(requiredParam);
}
/*
	This function is for expected text data from the server with "POST" method and form to be submitted

	@param
	url		 			: A string containing the URL to which the request is sent.
	data	 			: Form Data to be sent to the server
*/

export function formPost(url, data = {}) {
  const requiredParam = {
    dataType: 'text',
    method: 'POST',
    contentType: 'application/x-www-form-urlencoded',
    url,
    data
  };
  return ajaxWrapper(requiredParam);
}
/*
	This function is for expected json data from the server with "POST" method and form to be submitted

	@param
	url		 			: A string containing the URL to which the request is sent.
	data	 			: Form Data to be sent to the server
*/
export function formPostJsonResponse(url, data = {}) {
  const requiredParam = {
    dataType: 'json',
    method: 'POST',
    url,
    data
  };
  return ajaxWrapper(requiredParam);
}
